import React, { useEffect } from 'react';
import { sendEvent } from '../utils/tracking';

/**
 * Componente invisível para envio periódico de eventos.
 * Este componente é montado no App e gerencia eventos de visibilidade da página.
 */
const WebhookSender: React.FC = () => {
    useEffect(() => {
        // Função para enviar evento de saída da página
        const handleBeforeUnload = () => {
            sendEvent('page_leave', {
                timestamp: Date.now(),
                page_url: window.location.href
            });
        };

        // Função para enviar evento de visibilidade da página
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                sendEvent('page_hidden', {
                    timestamp: Date.now()
                });
            } else if (document.visibilityState === 'visible') {
                sendEvent('page_visible', {
                    timestamp: Date.now()
                });
            }
        };

        // Adicionar listeners
        window.addEventListener('beforeunload', handleBeforeUnload);
        document.addEventListener('visibilitychange', handleVisibilityChange);

        // Limpar listeners ao desmontar
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    // Componente não renderiza nada visível
    return null;
};

export default WebhookSender; 